export const alliancesData = [
    { src: "/assets/imgs/home/alliances/cars.png", link: "https://www.aeromexico.com/es-mx" },
    { src: "/assets/imgs/home/alliances/nestle.png", link: "https://www.cemexmexico.com/" },
    { src: "/assets/imgs/home/alliances/abengoa.png", link: "https://www.fedex.com/es-mx/home.html" },
    { src: "/assets/imgs/home/alliances/orizaba.png", link: "https://www.oxxo.com/" },
    { src: "/assets/imgs/home/alliances/ostart.png", link: "https://www.pemex.com/Paginas/default.aspx" },
    { src: "/assets/imgs/home/alliances/scott.png", link: "https://www.walmart.com.mx/" },
];